function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "group_24",
    "data-name": "group 24",
    transform: "translate(7.146 1.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_23",
    "data-name": "path 23",
    d: "M1671.462 649.625h-19.974a5.707 5.707 0 0 0-5.706 5.706v28.533a5.707 5.707 0 0 0 5.706 5.706h19.974a5.707 5.707 0 0 0 5.706-5.706v-28.533a5.707 5.707 0 0 0-5.706-5.706zm-5.706 25.68h-14.268a1.427 1.427 0 0 1 0-2.853h14.268a1.427 1.427 0 0 1 .094 2.853.919.919 0 0 1-.095-.005zm5.706-7.134h-19.974a1.427 1.427 0 0 1 0-2.853h19.974a1.427 1.427 0 0 1 0 2.853zm0-7.134h-19.974a1.427 1.427 0 0 1 0-2.853h19.974a1.427 1.427 0 0 1 0 2.853z",
    transform: "translate(-1645.782 -646.046)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_24",
    "data-name": "path 24",
    d: "M1675.52 647.542h-20.2a5.688 5.688 0 0 0-4.367 2.062h20.947a7.018 7.018 0 0 1 7.018 7.018v29.29a5.7 5.7 0 0 0 2.326-4.585V653.27a5.728 5.728 0 0 0-5.724-5.728z",
    transform: "translate(-1645.781 -647.542)",
    style: {
      fill: "current"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHistory);
export default __webpack_public_path__ + "static/media/ic-history.727dc054f64720a089803c49ac7db1c7.svg";
export { ForwardRef as ReactComponent };